import React from 'react';
import { BrandRegistrationApplication } from '../../../app/models/BrandRegistration';
import InputField from '../../../components/InputField/InputField';
import TextAreaField from '../../../components/TextAreaField';

interface ApplicationStepProps {
    applicationData: BrandRegistrationApplication;
    isEditable: boolean;
    onUpdate: () => void;
}

const ApplicationStep: React.FC<ApplicationStepProps> = ({ applicationData, isEditable }) => {
    const handleDisabledChange = () => {
        // No hace nada porque el campo está deshabilitado
    };

    return (
        <div>
            <h4 className="mb-4">Datos de la Solicitud</h4>
            
            {!isEditable && (
                <div className="alert alert-info mb-4">
                    <i className="fas fa-info-circle me-2"></i>
                    Esta etapa ya está completada. Los datos se muestran en modo solo lectura.
                </div>
            )}

            <div className="row g-3">
                {/* Información del Solicitante */}
                <div className="col-12">
                    <h5 className="border-bottom pb-2 mb-3">Información del Solicitante</h5>
                </div>

                <div className="col-md-4">
                    <InputField
                        label="Nombres"
                        value={applicationData.applicant_first_name || ''}
                        onChange={handleDisabledChange}
                        disabled={true}
                    />
                </div>

                <div className="col-md-4">
                    <InputField
                        label="Apellido Paterno"
                        value={applicationData.applicant_paternal_last_name || ''}
                        onChange={handleDisabledChange}
                        disabled={true}
                    />
                </div>

                <div className="col-md-4">
                    <InputField
                        label="Apellido Materno"
                        value={applicationData.applicant_maternal_last_name || ''}
                        onChange={handleDisabledChange}
                        disabled={true}
                    />
                </div>

                <div className="col-md-6">
                    <InputField
                        type="email"
                        label="Email"
                        value={applicationData.applicant_email || ''}
                        onChange={handleDisabledChange}
                        disabled={true}
                    />
                </div>

                <div className="col-md-6">
                    <InputField
                        type="tel"
                        label="Teléfono"
                        value={applicationData.applicant_phone || ''}
                        onChange={handleDisabledChange}
                        disabled={true}
                    />
                </div>

                {/* Información de la Marca */}
                <div className="col-12 mt-4">
                    <h5 className="border-bottom pb-2 mb-3">Información de la Marca</h5>
                </div>

                <div className="col-md-6">
                    <InputField
                        label="Tipo de Marca"
                        value={
                            applicationData.mark_type === 'mixta' ? 'Mixta' :
                            applicationData.mark_type === 'figurativa' ? 'Figurativa' :
                            applicationData.mark_type === 'denominativa' ? 'Denominativa' : ''
                        }
                        onChange={handleDisabledChange}
                        disabled={true}
                    />
                </div>

                <div className="col-md-6">
                    <InputField
                        label="Nombre de la Marca"
                        value={applicationData.brand_name || ''}
                        onChange={handleDisabledChange}
                        disabled={true}
                    />
                </div>

                <div className="col-12">
                    <InputField
                        label="Palabras Clave"
                        value={applicationData.keywords || ''}
                        onChange={handleDisabledChange}
                        disabled={true}
                    />
                </div>

                {/* Imagen de la marca */}
                {applicationData.brand_image && (
                    <div className="col-12">
                        <label className="form-label fw-bold">Imagen de la Marca</label>
                        <div className="border rounded p-3 text-center">
                            <img 
                                src={applicationData.brand_image} 
                                alt="Marca" 
                                style={{ maxWidth: '300px', maxHeight: '300px' }}
                                className="img-fluid"
                            />
                        </div>
                    </div>
                )}

                {/* Servicios o Productos */}
                <div className="col-12 mt-4">
                    <h5 className="border-bottom pb-2 mb-3">Servicios o Productos</h5>
                </div>

                <div className="col-12">
                    <TextAreaField
                        label="Descripción de Servicios / Productos"
                        value={applicationData.services_description || ''}
                        onChange={handleDisabledChange}
                        rows={3}
                        disabled={true}
                    />
                </div>

            </div>
        </div>
    );
};

export default ApplicationStep;

